export default __webpack_public_path__ + "static/media/pic33-after.94bc824d.jpg";